var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 46.98,
    viewBox: "0 0 53 46.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "caution-sign_1_",
    "data-name": "caution-sign (1)",
    transform: "translate(0.001 -18.717)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M52.454,59.6,30.02,20.749a4.066,4.066,0,0,0-7.042,0L.544,59.6a4.066,4.066,0,0,0,3.521,6.1H48.934a4.066,4.066,0,0,0,3.521-6.1ZM4.065,61.631,26.5,22.783,48.934,61.631Z",
    transform: "translate(0)",
    fill: "#fc7373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M147.224,115l1.166,13.348a1.655,1.655,0,0,0,3.3,0L152.853,115a3.024,3.024,0,0,0,0-.492,2.825,2.825,0,1,0-5.629.492Z",
    transform: "translate(-123.539 -78.225)",
    fill: "#fc7373"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2.332,
    cy: 2.332,
    r: 2.332,
    transform: "translate(24.167 52.459)",
    fill: "#fc7373"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCaution);
export default __webpack_public_path__ + "static/media/alertCaution.32e7d649307d42d6408852c4f595acad.svg";
export { ForwardRef as ReactComponent };